<template>
  <div class="weeks">
    <div class="outline">
      <div
        v-for="(item, index) in stamps"
        :key="index"
        :class="[item !== '---' ? activeClass : '', weekClass[index]]"
      >
        {{ index + 1 }}週目<br />{{ item }}
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['stampsInfo'],
  data: function() {
    return {
      activeClass: 'active',
      weekClass: ['w1', 'w2', 'w3', 'w4']
    }
  },
  async created() {},
  mounted: function() {},
  computed: {
    stamps: function() {
      const stamps = this.stampsInfo.map(item =>
        moment(new Date(item.get_at)).format('YY.MM.DD')
      )

      for (let i = stamps.length; i < 4; i++) {
        stamps.push('---')
      }

      return stamps.slice(0, 4)
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.weeks {
  padding: 10px 0;
  font-weight: bold;
  font-size: 4vw;
  width: 100%;

  .outline {
    display: flex;
    justify-content: center;
    align-items: center;

    div {
      display: flex;
      justify-content: center;
      align-items: center;

      width: 100%;
      color: #656665;
      padding: 4px 10px;
      height: 60px;

      &:not(:last-child) {
        margin-right: 1px;
      }
      background: url('~@/assets/img/walk/hitogata_gray.png') no-repeat;
      background-color: #ffffff;
      background-size: 90%;
      background-position: center;
      &.w1 {
        &.active {
          background: url('~@/assets/img/walk/hitogata.png') no-repeat;
          background-color: #fda666;
          background-size: 90%;
          background-position: center;
          color: #ffffff;
        }
      }
      &.w2 {
        &.active {
          background: url('~@/assets/img/walk/hitogata.png') no-repeat;
          background-color: #fd8c5e;
          background-size: 90%;
          background-position: center;
          color: #ffffff;
        }
      }
      &.w3 {
        &.active {
          background: url('~@/assets/img/walk/hitogata.png') no-repeat;
          background-color: #fa6653;
          background-size: 90%;
          background-position: center;
          color: #ffffff;
        }
      }
      &.w4 {
        background: url('~@/assets/img/walk/hitogata_gray_4w.png') no-repeat;
        background-color: #ffffff;
        background-size: 90%;
        background-position: center;
        &.active {
          color: #ffffff;
          background: url('~@/assets/img/walk/hitogata_4w.png') no-repeat;
          background-color: #f94147;
          background-size: 90%;
          background-position: center;
        }
      }
    }
  }
}
</style>
